import React from 'react';
import { Autocomplete } from '../Autocomplete';
import { PEPTIDE_OPTIONS } from '../../constants/peptides';

interface SuggestedDosageAutocompleteProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  tooltip?: string;
}

export const SuggestedDosageAutocomplete: React.FC<SuggestedDosageAutocompleteProps> = (props) => {
  return (
    <Autocomplete
      {...props}
      label="Name"
      options={PEPTIDE_OPTIONS}
      placeholder="Type to search or create new..."
    />
  );
};